import { memo } from "react";
import * as Styled from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import { PriceDownTooltip } from "~/components/blocks/layout/global-navi/common/price-down-tooltip";
import { MenuButtonForAuth } from "~/components/blocks/layout/global-navi/desktop/left/dmm-menu/nav-menus/my-menu-item/menu-button-for-auth";
import { PATHS } from "~/const/paths";

const MENU_NAME = "マイアイテム";

type Props = {
  /** 選択中のメニュー */
  isActive: boolean;
  /** 認証が必要な場合にtrue */
  needsAuth: boolean;
};

export const MyMenuItem = memo((props: Props) => {
  const { isActive, needsAuth } = props;

  return (
    <Styled.LIList>
      <Styled.DivWrapper isActive={isActive}>
        {needsAuth ? <MenuButtonForAuth name={MENU_NAME} /> : <NextLink href={PATHS.MY_BOOKMARK}>{MENU_NAME}</NextLink>}
      </Styled.DivWrapper>

      <PriceDownTooltip isDesktop />
    </Styled.LIList>
  );
});

MyMenuItem.displayName = "MyMenuItem";
